<template>
  <div class="card">
    <div class="card-header">
      <h4 style="padding: 10px">Manage Admin</h4>
    </div>
    <div class="card-body">
      <!-- Tabs -->
      <ul class="nav nav-tabs menu-form" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="true">
            Profile Details
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="merchants-tab" data-bs-toggle="tab" href="#merchants" role="tab" aria-controls="merchants" aria-selected="false">
            Assigned Merchants
          </a>
        </li>
      </ul>

      <!-- Tab Content -->
      <div class="tab-content menu-form">
        <!-- Profile Tab -->
        <div class="tab-pane fade show active" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          <div class="row mt-4">
            <div class="col-md-12">
              <form class="form-horizontal">
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Full Name</label>
                  <div class="col-sm-10">
                    <input type="text" class="form-control" v-model="adminData.fullName" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Email</label>
                  <div class="col-sm-10">
                    <input type="email" class="form-control" v-model="adminData.email" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Mobile Number</label>
                  <div class="col-sm-10">
                    <input type="tel" class="form-control" v-model="adminData.mobileNumber" />
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Roles</label>
                  <div class="col-sm-10">
                    <div class="role-checkboxes">
                      <div v-for="role in roleTypes" :key="role" class="form-check">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          :id="role"
                          :value="role"
                          v-model="adminData.roles"
                        />
                        <label class="form-check-label" :for="role">
                          {{ role.replace(/_/g, ' ').toUpperCase() }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-10 offset-sm-2">
                    <button type="button" class="btn btn-primary" @click="updateProfile" :disabled="isUpdating">
                      {{ isUpdating ? 'Updating...' : 'Update Profile' }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Merchants Tab -->
        <div class="tab-pane fade" id="merchants" role="tabpanel" aria-labelledby="merchants-tab">
          <div class="row mt-4">
            <div class="col-12">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5>Assigned Merchants</h5>
                <button class="btn btn-primary" @click="showAssignMerchantModal">
                  Assign New Merchant
                </button>
              </div>
              
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Full Name</th>
                      <th>Email</th>
                      <th>Company Name</th>
                      <th>Mobile Number</th>
                      
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="merchant in assignedMerchants" :key="merchant.uuid">
                      <td>{{ merchant.fullName }}</td>
                      <td>{{ merchant.email }}</td>
                      <td>{{ merchant.companyName }}</td>
                      <td>{{ merchant.mobileNumber }}</td>
                      
                      <td>
                        <button class="btn btn-outline-danger btn-sm" @click="removeMerchant(merchant.uuid)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Assign Merchant Modal -->
    <div class="modal fade" id="assignMerchantModal" tabindex="-1" role="dialog" aria-labelledby="assignMerchantModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="assignMerchantModalLabel">Assign Merchant</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Select Merchant</label>
              <select class="form-control" v-model="selectedMerchantUuid">
                <option value="">Select a merchant</option>
                <option v-for="merchant in availableMerchants" :key="merchant.uuid" :value="merchant.uuid">
                  {{ merchant.companyName }} ({{ merchant.fullName }})
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="assignMerchant" :disabled="!selectedMerchantUuid">
              Assign Merchant
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: "ManageAdmin",
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      adminData: {
        fullName: "",
        email: "",
        mobileNumber: "",
        roles: []
      },
      assignedMerchants: [],
      availableMerchants: [],
      selectedMerchantUuid: "",
      roleTypes: [],
      isUpdating: false
    };
  },
  methods: {
    async getAdminDetails() {
      try {
        const response = await api.doGet(`/api/admin/profile/${this.$route.params.adminUuid}`);
        if (response.status === "00") {
          console.log("getAdminDetails", response.data);
          this.adminData = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch admin details");
        }
      } catch (error) {
        console.error("Error fetching admin details:", error);
        this.toast.error("An error occurred while fetching admin details");
      }
    },
    async getAssignedMerchants() {
      try {
        const response = await api.doGet(`/api/admin/merchants/${this.$route.params.adminUuid}`);
        if (response.status === "00") {
          this.assignedMerchants = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch assigned merchants");
        }
      } catch (error) {
        console.error("Error fetching assigned merchants:", error);
        this.toast.error("An error occurred while fetching assigned merchants");
      }
    },
    async getAvailableMerchants() {
      try {
        const response = await api.doGet('/api/merchant/list');
        if (response.status === "00") {
          // Filter out already assigned merchants
          console.log("getAvailableMerchants", response.data);
          this.availableMerchants = response.data.filter(
            merchant => !this.assignedMerchants.some(assigned => assigned.uuid === merchant.uuid)
          );
        } else {
          this.toast.error(response.message || "Failed to fetch available merchants");
        }
      } catch (error) {
        console.error("Error fetching available merchants:", error);
        this.toast.error("An error occurred while fetching available merchants");
      }
    },
    async getRoleTypes() {
      try {
        const response = await api.doGet('/api/admin/role-types');
        if (response.status === "00") {
          this.roleTypes = response.data;
        } else {
          this.toast.error(response.message || "Failed to fetch role types");
        }
      } catch (error) {
        console.error("Error fetching role types:", error);
        this.toast.error("An error occurred while fetching role types");
      }
    },
    showAssignMerchantModal() {
      this.selectedMerchantUuid = "";
      this.getAvailableMerchants();
      jQuery("#assignMerchantModal").modal("show");
    },
    async assignMerchant() {
      try {
        const payload = {
          adminUuid: this.$route.params.adminUuid,
          merchantUuid: this.selectedMerchantUuid
        };

        const response = await api.doPost('/api/admin/assign-merchant', payload);
        
        if (response.status === "00") {
          this.toast.success(response.message);
          jQuery("#assignMerchantModal").modal("hide");
          this.getAssignedMerchants();
        } else {
          this.toast.error(response.message || "Failed to assign merchant");
        }
      } catch (error) {
        console.error("Error assigning merchant:", error);
        this.toast.error("An error occurred while assigning the merchant");
      }
    },
    async removeMerchant(merchantUuid) {
      if (confirm("Are you sure you want to remove this merchant from the admin?")) {
        try {
          const payload = {
            adminUuid: this.$route.params.adminUuid,
            merchantUuid: merchantUuid
          };

          const response = await api.doPost('/api/admin/unassign-merchant', payload);
          
          if (response.status === "00") {
            this.toast.success(response.message);
            this.getAssignedMerchants();
          } else {
            this.toast.error(response.message || "Failed to remove merchant");
          }
        } catch (error) {
          console.error("Error removing merchant:", error);
          this.toast.error("An error occurred while removing the merchant");
        }
      }
    },
    async updateProfile() {
      if (!this.adminData.fullName || !this.adminData.email || !this.adminData.mobileNumber) {
        this.toast.error("Please fill in all required fields");
        return;
      }

      this.isUpdating = true;
      try {
        const payload = {
          adminUuid: this.$route.params.adminUuid,
          fullName: this.adminData.fullName,
          email: this.adminData.email,
          mobileNumber: this.adminData.mobileNumber,
          roles: this.adminData.roles
        };

        const response = await api.doPost('/api/admin/update-profile', payload);
        
        if (response.status === "00") {
          this.toast.success(response.message);
          this.getAdminDetails(); // Refresh the data
        } else {
          this.toast.error(response.message || "Failed to update profile");
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        this.toast.error("An error occurred while updating the profile");
      } finally {
        this.isUpdating = false;
      }
    }
  },
  mounted() {
    this.getAdminDetails();
    this.getAssignedMerchants();
    this.getRoleTypes();
  }
};
</script>

<style scoped>
.nav-tabs {
  border-bottom: 1px solid #424351;
}

.nav-tabs .nav-link {
  color: #fff;
  border: none;
  padding: 10px 20px;
}

.nav-tabs .nav-link.active {
  color: #fff;
  background: transparent;
  border-bottom: 2px solid #007bff;
}

.form-group {
  margin-bottom: 15px;
}

.form-group__label {
  display: block;
  margin-bottom: 5px;
  color: #fff;
}

.form-control {
  background-color: #2b2e4c;
  color: #fff;
  border: 1px solid #424351;
}

.form-control:focus {
  background-color: #2b2e4c;
  color: #fff;
  border-color: #007bff;
  box-shadow: none;
}

textarea.form-control {
  resize: none;
}

.card {
  background: #2b2e4c;
  border-radius: 10px;
  padding: 20px;
}

.card-header {
  background: transparent;
  border-bottom: 1px solid #424351;
  padding: 15px 20px;
}

.card-body {
  padding: 20px;
}

.table {
  color: #fff;
}

.table thead th {
  border-bottom: 1px solid #424351;
  color: #fff;
}

.table td {
  border-top: 1px solid #424351;
}

.btn-outline-primary {
  color: #007bff;
  border-color: #007bff;
}

.btn-outline-primary:hover {
  background-color: #007bff;
  color: #fff;
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  color: #fff;
}

.modal-content {
  background-color: #2b2e4c;
  color: #fff;
}

.modal-header {
  border-bottom: 1px solid #424351;
}

.modal-footer {
  border-top: 1px solid #424351;
}

.close {
  color: #fff;
  text-shadow: none;
}

.close:hover {
  color: #fff;
  opacity: 0.75;
}

.role-checkboxes {
  margin-top: 10px;
}

.form-check {
  margin-bottom: 8px;
}

.form-check-input {
  background-color: #2b2e4c;
  border: 1px solid #424351;
}

.form-check-input:checked {
  background-color: #007bff;
  border-color: #007bff;
}

.form-check-label {
  color: #fff;
  margin-left: 5px;
}

.form-horizontal .form-group {
  margin-bottom: 1rem;
}

.form-horizontal .col-form-label {
  text-align: right;
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  color: #fff;
}

.role-checkboxes {
  padding-top: 0.375rem;
}

.form-check {
  margin-bottom: 0.5rem;
}

.form-check-label {
  color: #fff;
  margin-left: 0.5rem;
}
</style> 